export default "__VITE_ASSET__4ffbc38d__"